<template>
  <div
    :class="[
      $style.base,
      { [$style.isSmall]: isSmall, [$style.smallScreen]: $screen === 's' }
    ]"
  >
    <div :class="$style.inner">
      <Header />
      <div
        :class="$style.newsletter"
        class="ignore-theme"
        v-test="'preview-container'"
      >
        <div
          v-show="hasLogo && !!company.logo"
          :class="$style.logo"
        >
          <BaseImage
            v-if="company.logo"
            :cloudinaryId="company.logo.large"
            :width="100"
            v-test="'previewLogo'"
          />
        </div>
        <div
          v-show="hasImage"
          :class="$style.placeholderImage"
          v-test="'previewBanner'"
        >
          <BaseImage
            v-if="imageUrl"
            :cloudinaryId="imageUrl"
            :height="isSmall ? null : 280"
            cover
          />
        </div>
        <div :class="$style.content">
          <Message />
          <div
            v-show="showDiscount"
            :class="$style.discount"
          >
            <DiscountField v-test="'previewDiscountField'" />
          </div>
          <EmailButton
            v-show="hasButton"
            v-test="'previewMainButton'"
          />
        </div>
        <Footer :company="company" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { useCompanyStore } from '@/stores/company';
import { useMarketingStore } from '../../../store';
import { useMarketingBuilderStore } from '../../../store/builder';
import DiscountField from './DiscountField.vue';
import EmailButton from './EmailButton.vue';
import Footer from './Footer.vue';
import Header from './Header.vue';
import Message from './Message.vue';

export default defineComponent({
  setup() {
    const { company } = useCompanyStore();
    const { hasLogo, hasDiscount, hasButton, hasImage, imageUrl } = storeToRefs(
      useMarketingStore(),
    );
    return {
      company,
      hasLogo,
      hasDiscount,
      hasButton,
      hasImage,
      imageUrl,
    };
  },
  components: {
    Message,
    DiscountField,
    EmailButton,
    Footer,
    Header,
  },
  computed: {
    isSmall() {
      return this.$screen === 's' || this.selectedView === 'MOBILE';
    },
    showDiscount() {
      return this.hasDiscount;
    },
    selectedView() {
      const { selectedView } = useMarketingBuilderStore();
      return selectedView;
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  background: var(--color-bg-secondary);
  height: calc(100vh - 100px);
  overflow-y: auto;

  &.smallScreen {
    overflow: unset;
  }
}

.inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: $spacing;
}

.placeholderImage {
  background: var(--color-bg-secondary);
  height: 280px;
  width: 100%;

  .isSmall & {
    height: 100%;
    max-height: 280px;
  }
}

.newsletter {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: var(--shadow);
  background: var(--color-bg);
  max-width: 800px;
  width: 100%;

  .isSmall & {
    max-width: 340px;
  }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: $spacing * 2;
  max-width: 640px;
  padding: 0 $spacing;
  color: var(--color-text);
  padding-top: $spacing * 2;
}

.logo {
  margin-bottom: $spacing;
  margin-top: $spacing;
}

.discount {
  margin-bottom: $spacing;
  width: 100%;
}
</style>
